import type { LanguageCode } from "config/languages";

export const getLocaleFromFullSlug = (fullSlug: string) => fullSlug?.split("/")[0] as LanguageCode;
